import EmailIcon from '@mui/icons-material/Email'
import FacebookIcon from '@mui/icons-material/Facebook'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import MuiLink from '@mui/material/Link'
import { styled, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React from 'react'

import Section from '../Section'

const Link = styled(MuiLink)(
  ({ theme }) => `
  text-decoration: none;
  padding: 0 8px;
  color: ${theme.palette.secondary.main};
  :hover {
    color: ${theme.palette.primary.main};
  }
`,
)

const LogoLink = styled(MuiLink)`
  padding: 0px;
`

interface IconLinkProps {
  href: string
  label: string | JSX.Element
  icon?: JSX.Element
  target?: string
}
const IconLink: React.FC<IconLinkProps> = (props) => {
  return (
    <Link
      href={props.href}
      sx={{ display: 'flex', alignItems: 'center' }}
      target={props.target || ''}>
      {props.icon}
      {props.label}
    </Link>
  )
}

const Footer: React.FC = () => {
  const theme = useTheme()
  return (
    <Section secondary noMargin>
      <Container>
        <Grid
          container
          sx={(theme) => ({
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            [theme.breakpoints.down('sm')]: {
              flexDirection: 'column',
            },
          })}>
          <Grid
            sx={(theme) => ({
              display: 'flex',
              flexDirection: 'row',
              [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
              },
            })}>
            <Grid
              flexDirection="column"
              sx={{
                [theme.breakpoints.down('sm')]: {
                  alignSelf: 'center',
                },
              }}>
              <LogoLink
                href={`/`}
                sx={(theme) => ({
                  marginTop: theme.spacing(1),
                  marginBottom: theme.spacing(1),
                  [theme.breakpoints.up('sm')]: {
                    ml: 2,
                    mr: 4,
                  },
                })}
                underline="none">
                <img
                  height={65}
                  src={window.location.origin + '/images/megatechph_icon.png'}
                  alt="MEGATechPH"
                />
              </LogoLink>
            </Grid>
            <Grid
              container
              sx={(theme) => ({
                display: 'flex',
                alignSelf: 'center',
                flexDirection: 'column',
                [theme.breakpoints.down('sm')]: {
                  flexDirection: 'row',
                  justifyContent: 'center',
                },
              })}>
              <Grid>
                <IconLink
                  href="mailto:support@megatechph.com"
                  icon={<EmailIcon sx={{ mr: 1 }} />}
                  label="support@megatechph.com"
                />
              </Grid>
              <Grid>
                <IconLink
                  href="https://www.facebook.com/profile.php?id=100089710614257"
                  icon={<FacebookIcon sx={{ mr: 1 }} />}
                  label="MEGATechPH FB page"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            sx={(theme) => ({
              display: 'flex',
              flexDirection: 'column',
              [theme.breakpoints.down('sm')]: {
                alignItems: 'center',
                marginTop: 3,
              },
            })}>
            <Grid>
              <IconLink
                href="https://tracx.events/en/events/1328"
                target="_blank"
                label={
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                    }}>
                    Live Tracker
                  </Typography>
                }
              />
            </Grid>
            <Grid>
              <IconLink
                href="/events"
                label={
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                    }}>
                    Upcoming Events
                  </Typography>
                }
              />
            </Grid>
            <Grid>
              <IconLink
                href="/pastEvents"
                label={
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                    }}>
                    Past Events
                  </Typography>
                }
              />
            </Grid>
            <Grid>
              <IconLink
                href="https://www.results.megatechph.com/StartPage.aspx?CId=20402"
                target="_blank"
                label={
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                    }}>
                    Results
                  </Typography>
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Section>
  )
}
export default Footer
